import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { getItems } from './db/db';

import { Dashboard } from './Dashboard';
import { CreateCard } from './components/CreateCard';
import { MMCard } from './components/MMCard';
import { MyPinField } from './components/MyPINField';
import { Settings } from './components/Settings';
import { RemoveCardDialog } from './components/AlertDialog';

import './App.css';
import { WelcomeMessage } from './components/WelcomeMessage';
import { loadCards } from './store/cards.dispatch';

const DummyDashBoard = ({ components }) => {
  const editDashboard = useSelector(state => state.config.editableDashboard);
  return (
    <Dashboard editable={editDashboard}>
      {components.map((component, idx) =>
        <div
          key={'item-' + idx}
          i={'item-' + idx}
          className="rounded-md"
        >
          {component}
        </div>
      )}
    </Dashboard>
  );
}

function App() {
  const [arrayOfCards, setArrayOfCards] = useState([]);
  const cards = useSelector(state => state.cards.cards);

  useEffect(() => {
    loadCards();
  }, []);

  return (
    <div className="App">
      <WelcomeMessage />
      <MyPinField />
      <CreateCard />
      <RemoveCardDialog />
      <Settings size={64} />
      {
        cards.length > 0
          ? <DummyDashBoard components={cards.map(item => <MMCard cardId={item} />)} />
          : null
      }
    </div>
  );
}

export default App;
